import React, { Component } from 'react';
import { Apify } from '../Apify';
import { A, R } from '../routes';
import { short_site_id } from '../Site';

import ChangeArrow from './ChangeArrow';

const ticker_margin = 48;

const right_from = -100;
const right_to = 3000;

class TickerTapeInnerInner extends Component {
	constructor(props) {
		super(props);
		this.state = {
			tickers: []
		};
		this.next_serial = 1;
		this.ticker_refs = {};
		this.interval_handle = null;
		this.parent_ref = null;
	}

	push_tickers(ticker_specs) {
		if (ticker_specs.length === 0) return;
		const { tickertape } = this.props;
		const n_tickers = tickertape.length;
		var tickers_to_push = [];
		for (const ticker_spec of ticker_specs) {
			const left = ticker_spec.left || 0;
			const serial = this.next_serial++;
			const ticker = tickertape[serial % n_tickers];
			const href = R.href("/ticker/:exchange/:ticker", {exchange: ticker.Exchange, ticker: ticker.Ticker});
			const change_element = <ChangeArrow pct={ticker.Change*100} suffix="%"/>;
			const content = <A href={href} title={ticker.Name}>{ticker.Ticker} {change_element}</A>;
			tickers_to_push.push({content, serial, left});
		}
		this.setState((prev_state) => ({tickers: [...prev_state.tickers, ...tickers_to_push]}));
	}

	push_ticker(left) {
		this.push_tickers([{left}]);
	}

	update() {
		if (this.state.tickers.length === 0) {
			this.push_ticker();
		} else if (this.parent_ref && this.state.tickers.length > 0) {
			const getwx = (ref) => {
				const r = ref.getBoundingClientRect();
				return [r.width, r.x];
			};

			const [ parent_w, parent_x ] = getwx(this.parent_ref);

			const last_mover = this.state.tickers[this.state.tickers.length-1];
			const last_mover_ref = this.ticker_refs[last_mover.serial];
			if (last_mover_ref) {
				const [ lw, lx ] = getwx(last_mover_ref);
				const new_left = lx + lw + ticker_margin + right_from + 1 - parent_w - parent_x;
				if (new_left < 0) this.push_ticker(new_left);
			}

			/* garbage collect left-most tickers */
			var slice_at = 0;
			for (var i = 0; i < this.state.tickers.length; i++) {
				const mover = this.state.tickers[i];
				const ref = this.ticker_refs[mover.serial];
				if (!ref) continue;
				const [ mw, mx ] = getwx(ref);

				if (mx < ((parent_w - right_to) - mw)) {
					slice_at = i+1;
				}
			}
			if (slice_at > 0) {
				this.setState((prev_state) => ({tickers: prev_state.tickers.slice(slice_at)}));
			}

			/* garbage collect this.ticker_refs */
			var seen_serials = {};
			for (const mover of this.state.tickers) seen_serials[mover.serial] = true;
			var serials_to_remove = [];
			for (const serial in this.ticker_refs) if (!seen_serials[serial]) serials_to_remove.push(serial);
			for (const serial of serials_to_remove) delete this.ticker_refs[serial];
		}
	}

	componentDidMount() {
		this.interval_handle = setInterval(() => {
			this.update();
		}, 500);
	}

	componentWillUnmount() {
		if (this.interval_handle) {
			clearInterval(this.interval_handle);
			this.interval_handle = null;
		}
	}

	render() {
		var mover_elements = [];
		for (var mover of this.state.tickers) {
			((mover) => {
				const set_ref = (ref) => {
					this.ticker_refs[mover.serial] = ref;
				};
				const leftpx = mover.left + "px";
				mover_elements.push(
					<span key={mover.serial} className="ad_tickertape_ticker">
						<span ref={set_ref} className="ad_tickertape_ticker_inner" style={{left: leftpx}}>
							{mover.content}
						</span>
					</span>
				);
			})(mover);
		}

		const set_parent_ref = (ref) => {
			this.parent_ref = ref;
		}

		return (
			<div ref={set_parent_ref} className="ad_tickertape_parent">
				<span style={{opacity: 0}}>W</span> {/* just to give the ad_tickertape_parent span a proper height */}
				{mover_elements}
			</div>
		);
	}
}

const TickerTapeInner = (props) => {
	if (props.error) return null;
	return <TickerTapeInnerInner {...props}/>;
};

const TickerTape = Apify("/z/tickertape")
	.with_response_prop("tickertape")
	.with_query_from_props(props => ({site: short_site_id, lang: R.get_current_language()}))
	.with_4xx_prop("error")
	.with_refresh_interval(60)
	.wrap(TickerTapeInner);

function TickerTapeInjectCSS() {
	/* injecting manually to avoid maintaining constants here and in our
	 * CSS file */
	var style = document.createElement('style');
	document.head.appendChild(style);
	style.sheet.insertRule(`


@keyframes ad_tickertape_animation {
	from { right: ${right_from}px; }
	to { right: ${right_to}px; }
}


	`, 0)
}

export {
	TickerTape,
	TickerTapeInjectCSS,
}



// WEBPACK FOOTER //
// ./src/c/TickerTape.js